// extracted by mini-css-extract-plugin
export default {"signuppage":"signup_signuppage__AtTPP","signupPageBox":"signup_signupPageBox__NWM-U","signupaction":"signup_signupaction__OEHF3","signup_button":"signup_signup_button__6US7c"};